<!-- {{ filtrePrix }} -->

<div class="divTitre">
  <div id="titre">
    <!-- <div class="filtreBtnModal backTitle" style="margin-bottom: 2vh;cursor: pointer;" (click)="backDevis()">
      <img src="assets/img/back.svg" alt="" />
    </div> -->
    <p class="nombreFormule m-0">
      Voici les
      <span> {{ ' ' + nombreFormules + ' ' }} meilleures offres </span> pour
      vous
    </p>
    <p class="m-legale">
      <span class="text_prix"
        >Les offres d’assurance sont classées en fonction de leur
        prix&nbsp;</span
      >
      <span>(caractère non exhaustif des offres comparées)*</span>
    </p>
  </div>
  <div id="titreInfo">
    <div id="cardInfo">
      <div id="avatarDiv">
        <img src="assets/img/familleAvatar.svg" id="avatar" alt="" />
      </div>
      <div id="infoDiv">
        <div id="profilDiv">
          <span id="nom">{{ personne.nom }} {{ personne.prenom }}</span>
          <span id="age"> {{ valueAge }} ans &nbsp;&nbsp;</span>
          <span id="regime">{{ valueRegimeSociale }}</span>
        </div>
        <div id="dateDiv">
          <span id="dateContrat"
            >Date début de contrat : {{ formatDateDebutContrat }}</span
          >
        </div>
      </div>
      <!-- <img src="assets/img/pencil.svg" id="modifPencil" alt="" (click)="toggleModdal()" /> -->
      <div class="divAction">
        <div class="imgAction">
          <img
            src="assets/img/pencil.svg"
            id="modifPencil"
            alt=""
            (click)="toggleModdal()"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- modal info-->
  <div *ngIf="displayM" id="infoModal" class="modal">
    <div class="modal-content">
      <span class="closeInfo">
        <img [src]="imageUrlClose" alt="" (click)="toggleModdal()" />
      </span>
      <div class="modalContainer">
        <div id="avatarDiv">
          <img [src]="imageUrlFamilleAvatar" id="avatar" alt="" />
        </div>
        <div>
          <form [formGroup]="profileForm" (ngSubmit)="validateUpdate()">
            <div class="formulaireGroup">
              <div class="ligneGroup">
                <div class="inputGroup">
                  <label for="infoModalNom">Nom</label>
                  <input
                    type="text"
                    formControlName="nom"
                    (change)="changeName($event)"
                    id="infoModalNom"
                  />
                  @if (profileForm.get('nom')?.invalid) {
                    <p class="alertcss text-center child18">Nom invalide</p>
                  }
                </div>
                <div class="inputGroup">
                  <label for="infoModalPrenom">Prénom(s)</label>
                  <input
                    type="text"
                    formControlName="prenom"
                    id="infoModalPrenom"
                    (change)="changeFirstName($event)"
                  />
                  @if (profileForm.get('prenom')?.invalid) {
                    <p class="alertcss child18">Prénom invalide.</p>
                  }
                </div>
              </div>
              <div class="ligneGroup">
                <div class="inputGroup">
                  <label for="infoModalDateNaiss">Date de naissance</label>
                  <input
                    type="date"
                    formControlName="dateNaissanceAssure"
                    id="infoModalDateNaiss"
                    (change)="changeDateNaissance($event)"
                    min="{{ DateNaissanceMin | date: 'yyyy-MM-dd' }}"
                    max="{{ DateNaissanceMax | date: 'yyyy-MM-dd' }}"
                  />

                  @if (
                    profileForm.get('dateNaissanceAssure')?.hasError('maxDate')
                  ) {
                    <p class="alertcss child18">
                      Vous devez avoir plus de 18 ans pour souscrire un contrat
                      santé.
                    </p>
                  }

                  @if (
                    profileForm.get('dateNaissanceAssure')?.hasError('minDate')
                  ) {
                    <p class="alertcss child18">
                      Nous sommes désolés mais nous n’avons pas d’offre pour les
                      plus de 90 ans.
                    </p>
                  }
                </div>
                <div class="inputGroup">
                  <label for="infoModalRegime">Régime</label>
                  <select
                    id="infoModalRegime"
                    formControlName="regimeSocial"
                    (change)="changeRegimeSocial($event)"
                  >
                    <option value="0" [selected]="personne.regimeSocial == '0'">
                      Régime général
                    </option>
                    <option value="1" [selected]="personne.regimeSocial == '1'">
                      Travailleur non salarié
                    </option>
                    <option value="2" [selected]="personne.regimeSocial == '2'">
                      Sécurité sociale agricole
                    </option>
                    <option value="3" [selected]="personne.regimeSocial == '3'">
                      Alsace-moselle
                    </option>
                  </select>
                </div>
              </div>

              <div class="ligneGroup" style="justify-content: center">
                <div class="inputGroup" style="width: 60%">
                  <label for="infoModalDebutContrat"
                    >Date de début de contrat</label
                  >
                  <input
                    type="date"
                    formControlName="dateDebutContrat"
                    id="infoModalDebutContrat"
                    (change)="changeDateEffect($event)"
                    min="{{ healthEffectDateMin | date: 'yyyy-MM-dd' }}"
                    max="{{ dateEffetMax | date: 'yyyy-MM-dd' }}"
                  />

                  @if (
                    profileForm.get('dateDebutContrat')?.hasError('minDate')
                  ) {
                    <p class="alertcss child18">
                      La date d'effet doit être égale ou postérieure à
                      {{ healthEffectDateMin | date }}
                    </p>
                  }

                  @if (
                    profileForm.get('dateDebutContrat')?.hasError('maxDate')
                  ) {
                    <p class="alertcss child18">
                      La date d'effet ne peut pas être supérieur à 1 an.
                    </p>
                  }

                  @if (
                    profileForm.get('dateDebutContrat')?.hasError('minDate30')
                  ) {
                    <p class="alertcss child18">
                      La date d'effet ne peut être inférieure à 30 jours.
                    </p>
                  }
                </div>
                <!-- <div class="inputGroup">
                <label for=""><br /></label>
                <button id="addButton">
                  <img src="assets/img/plus.svg" alt="" />
                  Ajouter un bénéficiaire
                </button>
              </div> -->
              </div>
            </div>
            <button
              type="submit"
              class="modalButton"
              [ngClass]="
                profileForm.valid &&
                !(
                  !dateEffetValideANI() &&
                  formatDateEffetMaxPlus30 &&
                  profileForm.get('dateDebutContrat')?.value <
                    formatDateEffetMaxPlus30
                )
                  ? classeValideButton
                  : 'gray'
              "
              [disabled]="
                profileForm.invalid ||
                (!dateEffetValideANI() &&
                  formatDateEffetMaxPlus30 &&
                  profileForm.get('dateDebutContrat')?.value <
                    formatDateEffetMaxPlus30)
              "
            >
              Valider
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="divFiltre">
  <!-- <div id="titreFiltre">
      Vous pouvez modifier vos critères :
  </div> -->

  <div class="blocFiltre">
    <div class="filtreTriBloc" *ngIf="!filtreDisplay">
      <select
        id="filtreTri"
        [(ngModel)]="filtrePrix"
        (change)="changeFiltrePrix()"
      >
        <option value="croissant">Prix croissant</option>
        <option value="decroissant">Prix décroissant</option>
      </select>
    </div>
    <div class="filtreBtnModal" *ngIf="!filtreDisplay">
      <button (click)="displayFiltre()">
        Modifier mes critères
        <img src="assets/img/filtre.svg" alt="" />
      </button>
    </div>
    <div class="layoutFiltre" id="layoutFiltreId" *ngIf="filtreDisplay">
      <div id="filtreModal">
        <div class="filtreModalTitre">
          <div class="filtreModalTexte">
            Modifier mes critères
            <img src="assets/img/filtre.svg" id="critereImg" alt="" />
          </div>
          <div class="filtreModalTitreClose" (click)="displayFiltre()">
            <img
              src="assets/img/close-alt.svg"
              id="filtreModalTitreCloseBtn"
              alt=""
            />
          </div>
        </div>
        <div class="filtreModalMain" [ngClass]="originContainer">
          <div class="filtre">
            <div class="titreChoix">
              <div class="imageTitreChoix soinsMedicauxImg">
                <img [src]="heartbeat_solid" style="width: 80%" alt="" />
              </div>
              <div class="texteTitreChoix">Soins médicaux</div>
            </div>
            <div class="radio" id="soinsButton">
              <input
                label="Mini"
                type="radio"
                id="miniSoins"
                name="filtreSoins"
                [checked]="
                  personne.niveauRemboursement.soinsMedicaux == 'Minimum'
                "
                value="Minimum"
                [(ngModel)]="personne.niveauRemboursement.soinsMedicaux"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Moyen"
                type="radio"
                id="moyenSoins"
                name="filtreSoins"
                [checked]="
                  personne.niveauRemboursement.soinsMedicaux == 'Moyen'
                "
                value="Moyen"
                [(ngModel)]="personne.niveauRemboursement.soinsMedicaux"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Fort"
                type="radio"
                id="fortSoins"
                name="filtreSoins"
                [checked]="personne.niveauRemboursement.soinsMedicaux == 'Fort'"
                value="Fort"
                [(ngModel)]="personne.niveauRemboursement.soinsMedicaux"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Maxi"
                type="radio"
                id="maxiSoins"
                name="filtreSoins"
                [checked]="
                  personne.niveauRemboursement.soinsMedicaux == 'Maximum'
                "
                value="Maximum"
                [(ngModel)]="personne.niveauRemboursement.soinsMedicaux"
                (change)="validateUpdateNvRemb()"
              />
            </div>
          </div>
          <div class="filtre">
            <div class="titreChoix">
              <div class="imageTitreChoix hospiAmbulanceImg">
                <img [src]="ambulanceFilter" style="width: 80%" alt="" />
              </div>
              <div class="texteTitreChoix">Hospitalisation</div>
            </div>
            <div class="radio" id="hospiButton">
              <input
                label="Mini"
                type="radio"
                id="miniHospi"
                name="filtreHospi"
                [checked]="personne.niveauRemboursement.hospi == 'Minimum'"
                value="Minimum"
                [(ngModel)]="personne.niveauRemboursement.hospi"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Moyen"
                type="radio"
                id="moyenHospi"
                name="filtreHospi"
                [checked]="personne.niveauRemboursement.hospi == 'Moyen'"
                value="Moyen"
                [(ngModel)]="personne.niveauRemboursement.hospi"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Fort"
                type="radio"
                id="fortHospi"
                name="filtreHospi"
                [checked]="personne.niveauRemboursement.hospi == 'Fort'"
                value="Fort"
                [(ngModel)]="personne.niveauRemboursement.hospi"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Maxi"
                type="radio"
                id="maxiHospi"
                name="filtreHospi"
                [checked]="personne.niveauRemboursement.hospi == 'Maximum'"
                value="Maximum"
                [(ngModel)]="personne.niveauRemboursement.hospi"
                (change)="validateUpdateNvRemb()"
              />
            </div>
          </div>
          <div class="filtre">
            <div class="titreChoix">
              <div class="imageTitreChoix dentaireImg">
                <img [src]="tooth_solid" style="width: 80%" alt="" />
              </div>
              <div class="texteTitreChoix">Dentaire</div>
            </div>
            <div class="radio" id="dentaireButton">
              <input
                label="Mini"
                type="radio"
                id="miniDent"
                name="filtreDent"
                [checked]="personne.niveauRemboursement.dentaire == 'Minimum'"
                value="Minimum"
                [(ngModel)]="personne.niveauRemboursement.dentaire"
                (change)="validateUpdateNvRemb()"
              />

              <input
                label="Moyen"
                type="radio"
                id="moyenDent"
                name="filtreDent"
                [checked]="personne.niveauRemboursement.dentaire == 'Moyen'"
                value="Moyen"
                [(ngModel)]="personne.niveauRemboursement.dentaire"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Fort"
                type="radio"
                id="fortDent"
                name="filtreDent"
                [checked]="personne.niveauRemboursement.dentaire == 'Fort'"
                value="Fort"
                [(ngModel)]="personne.niveauRemboursement.dentaire"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Maxi"
                type="radio"
                id="maxiDent"
                name="filtreDent"
                [checked]="personne.niveauRemboursement.dentaire == 'Maximum'"
                value="Maximum"
                [(ngModel)]="personne.niveauRemboursement.dentaire"
                (change)="validateUpdateNvRemb()"
              />
            </div>
          </div>
          <div class="filtre">
            <div class="titreChoix">
              <div class="imageTitreChoix optiqueImg">
                <img [src]="glasses_alt_regular" style="width: 80%" alt="" />
              </div>
              <div class="texteTitreChoix">Optique</div>
            </div>
            <div class="radio" id="optiqueButton">
              <input
                label="Mini"
                type="radio"
                id="miniOpti"
                name="filtreOpti"
                [checked]="personne.niveauRemboursement.optique == 'Minimum'"
                value="Minimum"
                [(ngModel)]="personne.niveauRemboursement.optique"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Moyen"
                type="radio"
                id="moyenOpti"
                name="filtreOpti"
                [checked]="personne.niveauRemboursement.optique == 'Moyen'"
                value="Moyen"
                [(ngModel)]="personne.niveauRemboursement.optique"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Fort"
                type="radio"
                id="fortOpti"
                name="filtreOpti"
                [checked]="personne.niveauRemboursement.optique == 'Fort'"
                value="Fort"
                [(ngModel)]="personne.niveauRemboursement.optique"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Maxi"
                type="radio"
                id="maxiOpti"
                name="filtreOpti"
                [checked]="personne.niveauRemboursement.optique == 'Maximum'"
                value="Maximum"
                [(ngModel)]="personne.niveauRemboursement.optique"
                (change)="validateUpdateNvRemb()"
              />
            </div>
          </div>
          <div class="filtre">
            <div class="titreChoix">
              <div class="imageTitreChoix auditImg">
                <img [src]="ear_solid" style="width: 80%" alt="" />
              </div>
              <div class="texteTitreChoix">Aides auditives</div>
            </div>
            <div class="radio" id="auditButton">
              <input
                label="Mini"
                type="radio"
                id="miniAudit"
                name="filtreAudit"
                [checked]="personne.niveauRemboursement.auditive == 'Minimum'"
                value="Minimum"
                [(ngModel)]="personne.niveauRemboursement.auditive"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Moyen"
                type="radio"
                id="moyenAudit"
                name="filtreAudit"
                [checked]="personne.niveauRemboursement.auditive == 'Moyen'"
                value="Moyen"
                [(ngModel)]="personne.niveauRemboursement.auditive"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Fort"
                type="radio"
                id="fortAudit"
                name="filtreAudit"
                [checked]="personne.niveauRemboursement.auditive == 'Fort'"
                value="Fort"
                [(ngModel)]="personne.niveauRemboursement.auditive"
                (change)="validateUpdateNvRemb()"
              />
              <input
                label="Maxi"
                type="radio"
                id="maxiAudit"
                name="filtreAudit"
                [checked]="personne.niveauRemboursement.auditive == 'Maximum'"
                value="Maximum"
                [(ngModel)]="personne.niveauRemboursement.auditive"
                (change)="validateUpdateNvRemb()"
              />
            </div>
          </div>
        </div>
        <input
          type="submit"
          value="Appliquer"
          (click)="displayFiltre()"
          class="modalButton"
        />
      </div>
    </div>
  </div>
</div>
